/** Public routes using app/(marketing)/layout.tsx. Keep new marketing routes here. */
const marketingRouteRoots = new Set([
  'axcelerate',
  'blog',
  'contact',
  'cookie-policy',
  'design-standards',
  'docs',
  'dpa',
  'faq',
  'pricing',
  'privacy-policy',
  'terms-of-service',
]);

export function isMarketingPathname(pathname: string | null): boolean {
  if (pathname === '/') return true;
  if (!pathname?.startsWith('/')) return false;

  const root = pathname.split('/')[1];
  return root !== undefined && marketingRouteRoots.has(root);
}
